<div class="container sell-details__carousel_auctionInfo">
  <div class="row">
    <section class="sell-details__carousel">
      <app-grid-carousel-toggle [gridcarouselToggle]="autoVisionCarouselTranslations.gridCarouselData" [images]="images$ | async"
        (isImageGrid)="showImageGrid = $event">
      </app-grid-carousel-toggle>
    </section>
  </div>
  <div class="row">
    <section class="sell-details__carousel">
      @if (slickAvailable && !showImageGrid) {
        <app-carousel [images]="images$ | async" [carouselTranslate]="autoVisionCarouselTranslations.carouselData" (analyticsEvent)="consumeAnalyticsEvent($event)"
          >
        </app-carousel>
      }
      @if (slickAvailable && showImageGrid) {
        <app-image-grid [images]="images$ | async" [imageGridTranslation]="autoVisionCarouselTranslations.imageGridTranslations" (analyticsEvent)="consumeAnalyticsEvent($event)"
        ></app-image-grid>
      }
      @if (!slickAvailable) {
        <div>
          <h2 class="text-danger" data-test-id="app-auto-vision-carousel-e-header">{{autoVisionCarouselTranslations.slickSlider}}</h2>
          <p>
            <strong class="text-danger">{{autoVisionCarouselTranslations.refreshPage}}</strong>
          </p>
        </div>
      }
    </section>
  </div>
</div>
